module.exports = __webpack_public_path__ + "static/media/DM-Positive-Clip-3.f92cfab1.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/success/DM-Positive-Clip-3.mp3
// module id = 125
// module chunks = 0